import {Modal} from "react-bootstrap";

import {Button} from "@/components/button/Button.tsx";

interface SkipOnboardingModalProps {
  onSubmit: () => void;
  showSkipModal: boolean;
  setShowSkipModal: (showSkipModal: boolean) => void;
}

export const SkipOnboardingModal = ({showSkipModal, setShowSkipModal, onSubmit}: SkipOnboardingModalProps) => {
  return (
    <Modal show={showSkipModal} centered onHide={() => setShowSkipModal(false)}>
      <Modal.Header closeButton>
        <div className="pulseTextH2Bold pulse-color-gray-800">Skip Onboarding</div>
      </Modal.Header>
      <Modal.Body className="pulseTextBody pulse-color-gray-800">
        Are you sure you would like to skip Uptime.com guided onboarding?
      </Modal.Body>
      <Modal.Footer className="p-3 d-flex gap-2 align-items-sm-center align-items-start justify-content-end flex-column flex-sm-row">
        <Button onClick={onSubmit} className="d-sm-none m-0">
          Yes – Start Using Uptime
        </Button>
        <Button variant="secondary" onClick={() => setShowSkipModal(false)} data-bs-dismiss="modal" className="m-0">
          Back
        </Button>
        <Button onClick={onSubmit} className="d-none d-sm-block m-0">
          Yes – Start Using Uptime
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
